export var QueryPreviewTabs;
(function (QueryPreviewTabs) {
    QueryPreviewTabs[QueryPreviewTabs["data"] = 0] = "data";
    QueryPreviewTabs[QueryPreviewTabs["queryinfo"] = 1] = "queryinfo";
    QueryPreviewTabs[QueryPreviewTabs["apiConfig"] = 2] = "apiConfig";
    QueryPreviewTabs[QueryPreviewTabs["querySubscriptions"] = 3] = "querySubscriptions";
    QueryPreviewTabs[QueryPreviewTabs["queryTags"] = 4] = "queryTags";
    QueryPreviewTabs[QueryPreviewTabs["actions"] = 5] = "actions";
})(QueryPreviewTabs || (QueryPreviewTabs = {}));
export function isRtkQuery262Provided(provided) {
    return ('tags' in provided &&
        'keys' in provided &&
        typeof provided.tags === 'object' &&
        typeof provided.keys === 'object');
}
